import { ArticleSearchCategory } from '#lib/websites/news/constants/categories.js';

export const getSortedCategories = (categories: string[] | undefined) => {
	const lowerCaseCategories = categories?.map((cat) => cat.toLowerCase()) || [];

	return (lowerCaseCategories || []).includes(ArticleSearchCategory.shoutouts)
		? [
				ArticleSearchCategory.shoutouts,
				...lowerCaseCategories.filter(
					(category) => category !== ArticleSearchCategory.shoutouts
				),
			]
		: lowerCaseCategories;
};
